var escape = require("../../../node_modules/_css-loader@0.28.11@css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/_css-loader@0.28.11@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".no-login[data-v-2b1f265e]{text-align:center}.no-login-ico[data-v-2b1f265e]{width:2.4rem;height:2.4rem;background:url(" + escape(require("../../assets/images/ico_denglu.png")) + ") no-repeat 50%/cover;border-radius:50%;margin:.1rem auto .2rem}.no-login-info[data-v-2b1f265e]{margin-bottom:.3rem;font-size:.3rem;font-weight:400}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/_css-loader@0.28.11@css-loader?minimize!./node_modules/_vue-loader@13.7.3@vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2b1f265e","scoped":true,"hasInlineConfig":false}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=styles&index=0!./src/components/basic/nologin.vue
// module id = 5nNn
// module chunks = 29